import type { NavCopy } from './nav-en';

export const NAV_AR: NavCopy = {
  links: [
    { label: 'الباقات', href: '/pricing' },
    { label: 'الثقة',   href: '/trust', live: true },
  ],
};
